/**
 * TanStack Router: /reports
 *
 * This route file was auto-generated by the route generation script.
 * Component: ReportsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import ReportsPage from '@/app/reports/page'

/**
 * Route: /reports
 * Layout: _auth (authenticated)
 * Component: ReportsPage
 */
export const Route = createFileRoute('/_auth/reports')({
  component: ReportsPage,
})
